import { Tooltip } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { Card, Container, Form, OverlayTrigger } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Clinic, getClinics } from "../../services/getFunctions";
import { useAlertHelpers } from "../../helper/Hooks/useAlertHelpers";
import Logo from "../../img/Logo.svg";
import {
  AdminRegistrationData,
  registerUser,
} from "../../services/postFunctions";

// icons
import { RiInformationFill } from "react-icons/ri";
import { toErrorType } from "../../helper/alertBoxes";

/**
 * Component for admin registration.
 */
interface RegistrationState {
  value: string;
  username: string;
  password: string;
  isInvalid: boolean;
  unauthorized: boolean;
  clinics: Clinic[];
  isUsernameValid: boolean;
}

interface RegistrationProps {
  title: string;
}

const Registration = ({ title }: RegistrationProps) => {
  const [state, setState] = useState<RegistrationState>({
    value: "",
    username: "",
    password: "",
    isInvalid: true,
    unauthorized: true,
    clinics: [],
    isUsernameValid: true,
  });

  const {
    reportGetClinicianListError,
    reportRegistAdminError,
    showAlertModal,
  } = useAlertHelpers();

  /**Method loads clinic list from backend. */
  useEffect(() => {
    document.title = title;

    const loadClinics = async () => {
      try {
        const clinics = await getClinics();
        console.log("Klinik-Liste: ", clinics);
        setState((prevState) => ({
          ...prevState,
          clinics: clinics.clinics,
        }));
      } catch (error) {
        reportGetClinicianListError(toErrorType(error));
        console.log("Component of Registration did not mount successfully.");
      }
    };

    loadClinics();
  }, [title, reportGetClinicianListError]);

  /**Method to update the clinic id state, when it is changed.
   * @param event {ChangeEvent} onChange delivers the event with the selected option
   */
  const handleClinicId = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setState((prevState) => ({
      ...prevState,
      value: event.target.value,
    }));
    console.log("Klinik-ID: ", state.value);
  };

  /**Method to update the username state, when it is changed.
   * @param e {ChangeEvent} onChange delivers the event with the changed input
   */
  const handleUsername = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    console.log("Username", value, " ausgefüllt");
    const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?\s]/.test(value);
    setState((prevState) => ({
      ...prevState,
      username: value,
      isUsernameValid: !hasSpecialChar,
    }));
  };

  /**Handle method for admin registration. */
  const handleRegist = async (event: React.ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!state.username) {
      console.info("Kein Username");
      return;
    }

    if (!state.value || state.value === "") {
      console.info("Keine Klinik");
      return;
    }

    const adminData: AdminRegistrationData = {
      clinic_id: state.value,
      username: state.username,
    };

    try {
      const response = await registerUser(adminData, "admin");
      setState((prevState) => ({
        ...prevState,
        unauthorized: false,
        password: response.data,
      }));
      console.log("Response:", response.status);
      console.log(response.data);
      showAlertModal(
        "Ihr Passwort lautet: " +
          response.data +
          "\nIhr Account muss noch freigeschaltet werden.",
      );
    } catch (error) {
      reportRegistAdminError(toErrorType(error));
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center min-vh-100 pb-5">
      <Card className="col-lg-6 col-md-10">
        <Card.Header className="card-header bg-transparent d-flex justify-content-center">
          <img src={Logo} alt="Logo" width="230px" height="auto" />
        </Card.Header>
        <Card.Body className="p-5">
          <Card.Title className="text-dark mb-4">
            Registrierung Administrator
          </Card.Title>
          <Form noValidate validated onSubmit={handleRegist}>
            <Form.Group controlId="formGroupCode">
              <Form.Label>
                Benutzername{" "}
                <OverlayTrigger
                  overlay={
                    <Tooltip className="tooltip">
                      Der Benutzername darf keine Leer- oder Sonderzeichen
                      enthalten.
                    </Tooltip>
                  }
                >
                  <span className="mdi">
                    <RiInformationFill />
                  </span>
                </OverlayTrigger>
              </Form.Label>

              <Form.Control
                required
                type="username"
                placeholder="Benutzername"
                onChange={handleUsername}
                pattern="[A-Za-z0-9]+"
              />
              {!state.isUsernameValid && (
                <Form.Control.Feedback type="invalid">
                  Der Benutzername darf keine Leer- oder Sonderzeichen
                  enthalten.
                </Form.Control.Feedback>
              )}
              <Form.Control.Feedback type="invalid">
                Bitte geben Sie Ihren Benutzernamen ein.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formGroupCode">
              <Form.Label>Klinikname </Form.Label>
              <Form.Select
                className="form-control"
                required
                defaultValue=""
                onChange={handleClinicId}
              >
                {state.clinics &&
                  state.clinics.length > 0 &&
                  [
                    {
                      name: "Bitte auswählen",
                      id: "",
                    },
                    ...state.clinics,
                  ].map((clinic, index) => {
                    return (
                      <option key={index} value={clinic.id}>
                        {clinic.name}
                      </option>
                    );
                  })}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Bitte geben Sie den Kliniknamen ein.
              </Form.Control.Feedback>
            </Form.Group>

            <div className="d-grid gap-2">
              <Button className="margin-top" variant="primary" type="submit">
                Registrieren
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Registration;
